module.exports = __webpack_public_path__ + "static/media/Ichikawa_2f_New.999725f3.png";